class ListCollections extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      listCollections: '.list-collections',
      collectionCard: '.collection-card',
      item: '.list-collections > .grid__item',
      listCollectionsViewAs: '.list-collections__view-as span',
    };

    this.listCollections = this.querySelector(this.selectors.listCollections);
    this.items = this.querySelectorAll(this.selectors.item);
    this.viewAs = this.querySelectorAll(this.selectors.listCollectionsViewAs);

    this._setupEventListeners();

    const items = Array.from(this.items).sort((a, b) => +a.getAttribute('data-order') - +b.getAttribute('data-order'));
    this.listCollections.innerHTML = '';
    items.forEach(item => this.listCollections.append(item));
  }

  _setupEventListeners() {
    this.viewAs.forEach(el => {
      el.addEventListener('click', event => {
        this.viewAs.forEach(el => el.classList.remove('active'));
        event.currentTarget.classList.add('active');
        this.listCollections.classList.toggle(
          'list-collections-view-list',
          event.currentTarget.classList.contains('list-view'),
        );
      });
    });
  }
}

customElements.define('list-collections', ListCollections);
